module.exports = __webpack_public_path__ + "static/media/book-1.e0472592.png";